const baseURL = "/v1/Usuario";

const service = {
  methods: {
    $buscarUsuarios(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $cadastrarUsuario(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarUsuario(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $buscarLotacoesUsuario(params) {
      return this.$api().get(`${baseURL}/Lotacoes`, params);
    },
    $visualizarUsuario(id, params) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $inativarAtivarUsuario(body, id) {
      return this.$api().patch(`${baseURL}/${id}`, body);
    }
  },
};

export default service;
